
import { Vue, Options } from "vue-class-component";
import { Prop } from "vue-property-decorator";
import ButtonLoading from "./ButtonLoading.vue";

@Options({
  components: {
    ButtonLoading
  }
})
export default class ActionButton extends Vue {
  @Prop({ type: String }) title = "Button";
  @Prop({ type: String }) color: "primary" | "default" | "secondary" | "danger" | "warn" = "default";
  @Prop({ type: String }) shape: "round" | "rect" = "rect";
  @Prop({ type: String }) icon?: string;
  @Prop({ type: String }) toggleTarget?: string;
  @Prop({ type: String }) type: "button" | "submit" | "reset" = "button";
  @Prop({ type: Number }) width?: number;
  @Prop({ type: Number }) height?: number;
  @Prop({ type: Boolean }) disabled?: boolean = false;
  @Prop({ type: Boolean }) isLoading?: boolean = false;
}
